<template>
  <div class="container">
    <div class="check" v-on:click="clicked()" :class="{ 'check-on': on, 'check-disabled':disabled }">
      <div ref="handle" class="handle" :class="{ 'handle-on': on, 'handle-disabled':disabled }"></div>
    </div>
    <div class="label">{{ $t(title) }}</div>
  </div>
</template>

<script>

export default {
  name: 'ui-check',
  props:{
    title:{default:"no-title"},
    val:{default:false},
    disabled:{default:false},
  },
  data:function(){
    return {
      on:false,
      init:false,
    }
  },
  methods:{
    switchOff(){
      this.on=false;
    },
    switchOn(){
      this.on=true;
    },
    clicked(){
      if(this.disabled){
        return;
      }
      this.on=!this.on;
      this.$emit('selected',this.on);
    },
    
  },
  created(){
    this.on=this.val; // set prop val to data val
  },
  mounted(){
   
  },
  watch:{
    val:function(nv){
      this.on=nv;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  display:flex;
  width:100%;
  align-items: center;
  margin-bottom:15px;
  
}
.check{
  cursor:pointer;
  display:inline-block;
  position:relative;
  border-radius:16px;
  width:50px;
  height:25px;
  border:1px solid #CCCCCC;
  background-color:#FFFFFF;
  margin-right:5px;
  /*box-shadow:inset 1px 1px 4px rgba(0,0,0,.20);*/
}

.check-on{
  transition:background-color .25s;
  border:1px solid #8CC63E;
 
}
.handle{
  border:1px solid #FFFFFF;
  position:absolute;
  width:50%;
  height:100%;
  border-radius:999999px;
  background-color:#CCCCCC;
  transform:translateX(0%);
  transition:transform .25s, background-color .25s;
}
.handle-on{
  border:1px solid #FFFFFF;
  transform:translateX(100%);
  background-color: #8CC63E;
}

.handle-disabled{
  border:1px solid #EEEEEE!important;
}
.check-disabled{
  background-color:#EEEEEE!important;
}


.label{
  flex:1;
}

</style>
